import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationPipe } from './pagination/pagination.pipe';
import { ProfilePicturePipe } from './profilePicture/profilePicture.pipe';
import { ChatPersonSearchPipe } from './search/chat-person-search.pipe';
import { UserSearchPipe } from './search/user-search.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { MailSearchPipe } from './search/mail-search.pipe';
import { DebuggerPipe } from 'src/app/shared/pipes/debugger.pipe';
import { Base64Pipe } from '../../shared/pipes/base64.pipe';
import { StripMidnightPipe } from 'src/app/shared/pipes/strip-midnight.pipe';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		PaginationPipe,
		ProfilePicturePipe,
		ChatPersonSearchPipe,
		UserSearchPipe,
		TruncatePipe,
		MailSearchPipe,
		DebuggerPipe,
		Base64Pipe,
		StripMidnightPipe
	],
	exports: [
		PaginationPipe,
		ProfilePicturePipe,
		ChatPersonSearchPipe,
		UserSearchPipe,
		TruncatePipe,
		MailSearchPipe,
		DebuggerPipe,
		Base64Pipe,
		StripMidnightPipe
	]
})
export class PipesModule { }
